import { createPermit } from "../api/permits";
import { createProject, markProjectCandidateAsProcessed } from "../api/projects";
import { setModalOpen } from "../redux/slices/inspectionsSlice";
import { setNewProjectModalOpen } from "../redux/slices/projectSlice";
import { apiSlice } from "../redux/rtkQuery/apiSlice";
import { linkifyAny } from "./linkify";

export const updatePMResults = (results: any, params: any) => {
  if (!results) {
    return [];
  }
  const token = params.search;
  const _results = results.reduce((arr, item) => {
    let inspectionCount = 0;
    const inspArr = item.inspections.split(',');
    if (inspArr.length === 1) {
      if (item.inspections !== '') {
        inspectionCount = inspArr.length;
      }
    } else {
      inspectionCount = inspArr.length;
    }
    if (item.managerName?.toLowerCase().indexOf(token.toLowerCase()) > -1) {
      arr.push({ ...item, inspections: `${inspectionCount}` });
    }
    return arr;
  }, []);
  return _results.sort((a, b) => {
    if (a?.managerEmail > b?.managerEmail) {
      return 1;
    }
    if (a?.managerEmail < b?.managerEmail) {
      return -1;
    }
    return 0;
  });
};

export const getAccountingInfo = (contacts, permitContactsRedux) => {
  return contacts.map(c => {
    const contact = permitContactsRedux.find(contact => {
      const id = contact.user ? contact.user : contact.id;
      return id === c.id;
    });
    return {
      ...c,
      isAccounting: contact ? contact.isAccounting : c.isAccounting,
      isInspection: contact ? contact.isInspection : c.isInspection,
      contactType: contact?.contactType ?? c.contactType,
    };
  });
};

export const persistNewProjectData = (projectCandidate, selectedProject, payload1, payload2, dispatch, refetch) => {
  const create = async () => {
    if (selectedProject) {
      // updating permit for this project
      await createPermit(payload2);
    } else {
      await createProject(payload1);
    }

    const _payload = {
      id: projectCandidate.id,
      is_visible: false,
      project_status: 'New',
    };
    await markProjectCandidateAsProcessed(_payload);
    await refetch();
    await dispatch(
      apiSlice.endpoints.getProjects.initiate(
        { limit: 25, offset: 0 },
        { forceRefetch: true, subscribe: false },
      ),
    );
    dispatch(apiSlice.util.invalidateTags(['Projects']));
    dispatch(setModalOpen(false));
    dispatch(setNewProjectModalOpen(false));
  };
  create();
};

export const copyToClipboard = async input => {
  await navigator.clipboard.writeText(input);
};

// Plain text or rich-text HTML → safe HTML with every URL as a link. See ./linkify.
export const getAnchorIfExists = str => linkifyAny(str);
